
import seo from '~/mixins/seo'

export default {
  head () {
    const metadata = seo.head.call(this)
    return { ...metadata, link: [...metadata.link,
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap' }
    ] }
  }
}
